import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'
import { isEqual, camelCase } from 'lodash'

import { sortReserveParameters, getReserveParameterByKey } from 'helpers/reserves'
import { RESERVE_TYPES, RESERVE_PARAMETERS_TYPES } from 'constants'

import {
    DEFAULT_LAYOUT_PARAMETERS_DESCRIPTION,
    RESERVES_PARAMETERS_DESCRIPTION,
} from './translations'

import styles from './BonusParametersDescription.scss'

const getParameterConfig = (key, currentBonus, nextBonus, isHighlighted) => {
    const currentValue = getReserveParameterByKey(currentBonus, key)
    const nextValue = getReserveParameterByKey(nextBonus, key)

    return {
        parameterName: key,
        value: isHighlighted ? nextValue : currentValue,
        isHighlightEnabled: isHighlighted && !isEqual(currentValue, nextValue),
    }
}

export const BonusParametersDescription = ({
    layoutType = 'default',
    reserveType,
    isNextLevelHighlighted,
    currentBonus,
    nextBonus,
    battleTypes,
}) => {
    const sortedReserveParameters = (
        Object.keys(currentBonus.parameters)
            .filter((parameter) => {
                const { DURATION, COMMON_DELAY } = RESERVE_PARAMETERS_TYPES
                return !(
                    layoutType !== 'tooltip' &&
                    [DURATION, COMMON_DELAY].includes(parameter)
                )
            })
            .sort(sortReserveParameters)
    )

    const reserveParameters = (() => {
        const clientParameters = sortedReserveParameters.map((key) => (
            getParameterConfig(key, currentBonus, nextBonus, isNextLevelHighlighted)
        ))

        if (layoutType === 'tooltip') {
            return clientParameters
        }

        const industrialResourceBonus = battleTypes.map((key) => {
            const config = getParameterConfig(key, currentBonus, nextBonus, isNextLevelHighlighted)

            const parameterName = (() => {
                switch (reserveType) {
                case RESERVE_TYPES.INSPIRATION:
                    return RESERVE_PARAMETERS_TYPES.INSPIRATION_INDUSTRIAL_RESOURCE_BONUS
                case RESERVE_TYPES.ARTILLERY_STRIKE:
                    return RESERVE_PARAMETERS_TYPES.ARTILLERY_STRIKE_INDUSTRIAL_RESOURCE_BONUS
                }
            })()

            return {
                ...config,
                parameterName,
                value: `+${config.value}`,
            }
        })

        return clientParameters.concat(industrialResourceBonus)
    })()

    return (
        <div className={cx(styles.base, styles[`base__${layoutType}Layout`])}>
            {reserveParameters.map(({ parameterName, value, isHighlightEnabled }, index) => {
                return (
                    <div className={styles.parameter} key={index}>
                        <span
                            className={cx(
                                styles.parameterValue,
                                isHighlightEnabled && styles.parameterValue__glow,
                                styles[`parameterValue__${camelCase(reserveType.toLowerCase())}`]
                            )}
                        >
                            {Array.isArray(value) ? (
                                value.map((value, index) => (
                                    <reactFragment key={index}>
                                        {index !== 0 && <span className={styles.valueSeparator}>{' / '}</span>}
                                        {value}
                                    </reactFragment>
                                ))
                            ) : (
                                value
                            )}
                        </span>
                        <span className={styles.parameterDescription}>
                            {layoutType === 'default' ?
                                DEFAULT_LAYOUT_PARAMETERS_DESCRIPTION[parameterName] :
                                RESERVES_PARAMETERS_DESCRIPTION[parameterName]
                            }
                        </span>
                    </div>
                )
            })}
        </div>
    )
}

BonusParametersDescription.propTypes = {
    layoutType: PropTypes.oneOf(['default', 'tooltip', 'toolbar']),
    currentBonus: PropTypes.object.isRequired,
    nextBonus: PropTypes.object.isRequired,
    reserveType: PropTypes.string.isRequired,
    isNextLevelHighlighted: PropTypes.bool,
    battleTypes: PropTypes.array.isRequired,
}

export default BonusParametersDescription



// WEBPACK FOOTER //
// ./components/ReserveBonus/components/BonusParametersDescription/BonusParametersDescription.jsx